import InputLabel from '@mui/material/InputLabel'
import { makeStyles } from '@mui/styles'
import { ThemeProvider, createTheme } from '@mui/material/styles'
// core components
import styles from 'assets/jss/style-component/components/customInputStyle.js'
import classNames from 'classnames'
import { GridItem } from 'components'
import PropTypes from 'prop-types'
import React from 'react'
import ReactTooltip from 'react-tooltip'
import { Input } from '@mui/material'

const useStyles = makeStyles(styles)

const theme = createTheme({
  components: {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: '#3c4858',
          fontSize: 'small  !important'
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          marginBottom: '10px !important',
          /*ckgroundColor: "#ffffff94",*/
          fontSize: 'small  !important'
        },
        input: {
          /*ckgroundColor: "#ffffff94",*/
          fontSize: 'small  !important'
        }
      }
    },

    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '4px',
          minHeight: '35px!important',
          '& $notchedOutline': {
            borderColor: 'rgba(0, 0, 0, 0.23)'
          },
          '&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
            borderColor: '#4A90E2',
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
              borderColor: 'rgba(0, 0, 0, 0.23)'
            }
          },
          '&$focused $notchedOutline': {
            borderColor: '#4A90E2',
            borderWidth: 1
          }
        }
      }
    }
  }
})

export default function CustomNumber(props) {
  const classes = useStyles()
  const {
    prefix,
    labelText,
    id,
    labelProps,
    value,
    error,
    success,
    disabled,
    //onValueChange,
    helperText,
    sm,
    md,
    blanco
  } = props
  const labelClasses = classNames({
    [' ' + classes.labelRootError]: error,
    [' ' + classes.labelRootSuccess]: success && !error,
    [' ' + classes.labelRootBlanco]: blanco && !success && !error
  })

  return (
    <GridItem xs={12} sm={sm === null ? 12 : sm} md={md}>
      <ThemeProvider theme={theme}>
        {labelText !== undefined ? (
          <InputLabel
            className={classes.labelRoot + labelClasses}
            htmlFor={id}
            {...labelProps}
          >
            {labelText}
          </InputLabel>
        ) : null}

        <Input
          type="number"
          data-tip={helperText}
          prefix={prefix}
          //decimalScale={2}
          value={value}
          //onValueChange={onValueChange}
          disabled={disabled}
        />

        <ReactTooltip />
      </ThemeProvider>
    </GridItem>
  )
}
CustomNumber.propTypes = {
  labelText: PropTypes.node,
  labelProps: PropTypes.object,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  formControlProps: PropTypes.object,
  value: PropTypes.string,
  defaultValue: PropTypes.object,
  error: PropTypes.bool,
  success: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onKeyPress: PropTypes.func,
  helperText: PropTypes.string,
  sm: PropTypes.number,
  md: PropTypes.number,
  prefix: PropTypes.string,
  //onValueChange: PropTypes.number,
  blanco: PropTypes.string
}
